import React from "react";
import "../components/Courses.css";


const Courses = () => {
  return (
    <div className="courses-container">
      <h1 className="courses-title">Our Courses</h1>
      <p className="courses-subtitle">
        At Gen Z Skills, we focus on building strong foundations with practical, interactive, and problem-solving based learning.
      </p>

      {/* C Programming Section */}
      <div className="course-card">
        <h2>C Programming</h2>
        <p>
          Learn one of the most powerful and widely used programming languages. 
          Our C course is designed to make you confident in coding and logic building.
        </p>
        <ul>
          <li>✨ Basics to Advanced C Concepts</li>
          <li>✨ Problem Solving with Real Examples</li>
          <li>✨ Analyzing and Writing Efficient Code</li>
          <li>✨ Strong Foundation for Other Languages</li>
          <li>✨ Mini Projects & Practice Problems</li>
        </ul>
      </div>

      {/* Problem Solving & Analytical Skills Section */}
      <div className="course-card">
        <h2>Problem Solving & Analytical Skills</h2>
        <p>
          We don’t just teach coding—we teach you how to think like a programmer. 
          Our lessons improve critical reasoning and help students develop 
          structured approaches to solving problems.
        </p>
        <ul>
          <li>🧠 Logical Thinking Strategies</li>
          <li>🧠 Breaking Problems into Steps</li>
          <li>🧠 Debugging & Optimization Techniques</li>
          <li>🧠 Hands-on Exercises with Feedback</li>
        </ul>
      </div>

      {/* Delivery & Learning Experience Section */}
      <div className="course-card">
        <h2>Our Teaching Method</h2>
        <p>
          We believe in learning by doing. Every session is designed to keep students engaged and practical. 
          Whether it’s coding or problem solving, our delivery is focused on results.
        </p>
        <ul>
          <li>✔️ Interactive Online Classes</li>
          <li>✔️ Recorded Sessions for Revision</li>
          <li>✔️ Real-World Examples & Projects</li>
          <li>✔️ Supportive Community & Mentorship</li>
        </ul>
      </div>
    </div>
  );
};

export default Courses;
